export enum KNXConnectionType {
    usb = 1,
    ip = 2,
    ipRouting = 3
}

export enum ImportETSRoomNumberCalculationKind {
    LastNChars = 1,
    LastSpace= 2
  };